const PUBLIC_STORAGE_PATH = '/storage/v1/object/public/';
const RENDER_STORAGE_PATH = '/storage/v1/render/image/public/';

const LEGACY_HERO_URL =
  'https://znqwidslhnznhiyfhdpf.supabase.co/storage/v1/object/public/products/1766749378461-pwgpw7.webp';
const LEGACY_HERO_FILE = '1766749378461-pwgpw7.webp';

export const getOptimizedStorageImage = (
  imageUrl: string,
  width: number,
  quality = 65,
) => {
  if (!imageUrl.includes(PUBLIC_STORAGE_PATH)) return imageUrl;

  try {
    const url = new URL(imageUrl);
    url.pathname = url.pathname.replace(PUBLIC_STORAGE_PATH, RENDER_STORAGE_PATH);
    url.searchParams.set('width', String(width));
    url.searchParams.set('quality', String(quality));
    url.searchParams.set('resize', 'cover');
    return url.toString();
  } catch {
    return imageUrl;
  }
};

export const getHeroImageSources = (imageUrl: string) => {
  // The original legacy cover is a 3 MB PNG saved with a .webp extension.
  // Keep local, properly encoded copies so the first visit is fast as well.
  if (imageUrl === LEGACY_HERO_URL || imageUrl.endsWith(`/${LEGACY_HERO_FILE}`)) {
    return {
      mobile: '/images/aseel-hero-mobile.jpg',
      desktop: '/images/aseel-hero-desktop.jpg',
    };
  }

  return {
    mobile: getOptimizedStorageImage(imageUrl, 760, 60),
    desktop: getOptimizedStorageImage(imageUrl, 1200, 68),
  };
};
